<template>
    <div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>收入</span>
            </div>
            <ul class="module-ul">
                <li class="module-li">
                    <span class="module-li-tit">
                        财产转让所得
                        <i class="icon iconfont icon-bangzhu-" @click="isShowCaichanzhuanrang = !isShowCaichanzhuanrang"></i>
                    </span>
                    <input v-model.lazy="caiwuzhuanrang" @change="caiwuzhuanrangChange" class="module-li-short" type="text">
                    <span>元</span>
                    <div v-show="isShowCaichanzhuanrang" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowCaichanzhuanrang = false"></i>
                        <h1>财产转让所得：</h1>
                        <p>是指个人转让有价证券、股权、合伙企业中的财产份额、不动产、土地使用权、机器设备、车船以及其他财产取得的所得</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>扣除及减除项目</span>
            </div>
            <ul class="module-ul">
                <li class="module-li">
                    <span class="module-li-tit">免税所得</span>
                    <input v-model.lazy="mianshui" @change="mianshuiChange" class="module-li-short" type="text">
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">
                        财产原值
                        <i class="icon iconfont icon-bangzhu-" @click="isShowCaichanyuanzhi = !isShowCaichanyuanzhi"></i>
                    </span>
                    <input v-model.lazy="caichanyuanzhi" @change="caichanyuanzhiChange" class="module-li-short" type="text">
                    <span>元</span>
                    <div v-show="isShowCaichanyuanzhi" class="explain">
                        <i class="icon iconfont icon-guanbi" @click="isShowCaichanyuanzhi = false"></i>
                        <h1>财产原值：</h1>
                        <p>取得财产时实际支付的费用</p>
                    </div>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">允许扣除的税费</span>
                    <input v-model.lazy="yunxukouchu" @change="yunxukouchuChange" class="module-li-short" type="text">
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">实际捐赠额</span>
                    <input v-model.lazy="shijijuanzeng" @change="shijijuanzengChange" class="module-li-short" type="text">
                    <span>元</span>
                </li>

            </ul>
        </div>
        <div class="btn" @click="computerClick">
            计算
        </div>
        <div class="module">
            <div class="module-tit">
                <img src="../../static/images/2.png" alt="">
                <span>计算结果</span>
            </div>
            <ul class="module-ul">
                <li class="module-li">
                    <span class="module-li-tit">税前收入</span>
                    <input v-model="beforeIncome" class="module-li-short" type="text" readonly>
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">应纳税额</span>
                    <input v-model="taxAmount" class="module-li-short" type="text" readonly>
                    <span>元</span>
                </li>
                <li class="module-li">
                    <span class="module-li-tit">税后收入</span>
                    <input v-model="afterIncome" class="module-li-short" type="text" readonly>
                    <span>元</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import number from '../../static/js/number'
    import unNumber from '../../static/js/unNumber'
    export default {
        data () {
            return {
                caiwuzhuanrang:'',//财务转让所得
                mianshui:'',//免税所得
                caichanyuanzhi:'',//财产原值
                yunxukouchu:'',//允许扣除的税费
                shijijuanzeng:'',//实际捐赠额

                isShowCaichanzhuanrang:false,//是否显示财产转让所得说明
                isShowCaichanyuanzhi:false,//是否显示财产原值说明

                beforeIncome:0,//税前收入
                taxAmount:0,//应纳税额
                afterIncome:0,//税后收入
            }
        },
        methods:{
            caiwuzhuanrangChange(){
                let val = unNumber.unNumber(this.caiwuzhuanrang)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.caiwuzhuanrang = '0.00'
                }else{
                    this.caiwuzhuanrang = number.number(this.caiwuzhuanrang)
                }
            },
            mianshuiChange(){
                let val = unNumber.unNumber(this.mianshui)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.mianshui = '0.00'
                }else{
                    this.mianshui = number.number(this.mianshui)
                }
            },
            caichanyuanzhiChange(){
                let val = unNumber.unNumber(this.caichanyuanzhi)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.caichanyuanzhi = '0.00'
                }else{
                    this.caichanyuanzhi = number.number(this.caichanyuanzhi)
                }
            },
            yunxukouchuChange(){
                let val = unNumber.unNumber(this.yunxukouchu)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.yunxukouchu = '0.00'
                }else{
                    this.yunxukouchu = number.number(this.yunxukouchu)
                }
            },
            shijijuanzengChange(){
                let val = unNumber.unNumber(this.shijijuanzeng)
                if(val <= 0){
                    alert('请正确输入金额')
                    this.shijijuanzeng = '0.00'
                }else{
                    this.shijijuanzeng = number.number(this.shijijuanzeng)
                }
            },

            computerClick(){
                let caiwuzhuanrang = unNumber.unNumber(this.caiwuzhuanrang) //财务转让所得
                let mianshui = unNumber.unNumber(this.mianshui) //免税所得
                let caichanyuanzhi = unNumber.unNumber(this.caichanyuanzhi)//财产原值
                let yunxukouchu = unNumber.unNumber(this.yunxukouchu)//允许扣除的税费
                let shijijuanzeng = unNumber.unNumber(this.shijijuanzeng)//实际捐赠额
                let x = 0
                x = (caiwuzhuanrang - mianshui - caichanyuanzhi - yunxukouchu) * 0.3 > shijijuanzeng ? shijijuanzeng : (caiwuzhuanrang - mianshui - caichanyuanzhi - yunxukouchu) * 0.3
                if(caiwuzhuanrang - mianshui - caichanyuanzhi - yunxukouchu > 0){
                    this.taxAmount = ((caiwuzhuanrang - mianshui - caichanyuanzhi - yunxukouchu - x) * 0.2).toFixed(2);

                }else{
                    this.taxAmount = 0
                }
                this.beforeIncome = number.number(caiwuzhuanrang);
                this.afterIncome = caiwuzhuanrang - shijijuanzeng > 0 ? number.number(caiwuzhuanrang - shijijuanzeng - this.taxAmount) : 0
                this.taxAmount = number.number(this.taxAmount)
            }
        },
    }
</script>
<style scoped>
    .module{
        width:100%;
        margin-top: 30px;
        text-align: left;
    }
    .module .module-tit{
        display: inline-block;
        border-bottom: 1px solid #1a96d4;
        padding: 5px 15px 5px 10px;
        font-size:16px;
    }
    .module .module-tit #all{
        width:16px;
        height:16px;
    }
    .module .module-ul{
        width:100%;
        font-size:0;
    }
    .module .module-ul .module-li{
        display: inline-block;
        width:50%;
        height:36px;
        font-size:14px;
        color: #333;
        margin-top:20px;
        position: relative;
    }
    .module .module-ul .module-li .module-li-tit{
        display: inline-block;
        width:140px;
        height:100%;
        font-size: 14px;
        margin-left: 20px;
        margin-right: 10px;
        vertical-align: middle;
    }
    .module .module-ul .module-li .module-li-tit .icon-bangzhu-{
        display: inline-block;
        float: right;
        font-size:20px;
        color: #1a96d4;
        cursor: pointer;
        vertical-align: middle;
    }
    .module .module-ul .module-li .module-li-short{
        display: inline-block;
        width:270px;
        height:32px;
        line-height: 1;
        font-size:14px;
        text-align: center;
        border: 1px solid #b9e9f2;
    }
    .module .module-ul .module-li .explain{
        display: block;
        width:500px;
        position: absolute;
        border: 1px solid #1a96d4;
        border-radius: 10px;
        top:36px;
        left:0px;
        background-color: #fff;
        z-index:100;
        padding: 10px 20px;
        box-shadow:5px 5px 20px -5px #ccc
    }
    .module .module-ul .module-li .explain .icon-guanbi{
        position: absolute;
        top:5px;
        right:5px;
        font-size:20px;
        cursor: pointer;
    }
    .module .module-ul .module-li .explain h1{
        font-size:20px;
        color: #333;
    }
    .module .module-ul .module-li .explain p{
        font-size:18px;
        color: #333;
    }
    .module .module-ul .module-li-choice .choice.selected{
        border: 1px solid #1a96d4;
        color: #1a96d4;
        background-color: #d1edf8;
    }
    .module .module-ul .module-subheading{
        width:100%;
        border-bottom: 1px solid #ccc;
        padding: 10px 0;
        position: relative;
    }
    .module .module-ul .module-subheading span{
        font-size:14px;
        color: #333;
        border-left:1px solid #1a96d4;
        padding-left: 10px;
    }
    .module .module-ul .module-subheading span .icon-bangzhu-{
        display: inline-block;
        font-size:20px;
        color: #1a96d4;
        cursor: pointer;
        vertical-align: middle;
    }
    .module .module-ul .module-subheading .explain{
        display: block;
        width:500px;
        position: absolute;
        border: 1px solid #1a96d4;
        border-radius: 10px;
        top:36px;
        left:0px;
        background-color: #fff;
        z-index:100;
        padding: 10px 20px;
        box-shadow:5px 5px 20px -5px #ccc
    }
    .module .module-ul .module-subheading .explain .icon-guanbi{
        position: absolute;
        top:5px;
        right:5px;
        font-size:20px;
        cursor: pointer;
    }
    .module .module-ul .module-subheading .explain h1{
        font-size:20px;
        color: #333;
    }
    .module .module-ul .module-subheading .explain p{
        font-size:18px;
        color: #333;
    }
    .module .module-ul .module-li-choice{
        display: inline-block;
        width:50%;
        height:36px;
        font-size:14px;
        color: #333;
        margin-top:20px;
    }
    .module .module-ul .module-li-choice .choice{
        width:440px;
        height:32px;
        border: 1px solid #ccc;
        text-align: center;
        line-height: 32px;
        color: #333;
        margin-left: 10px;
        cursor: pointer;
    }
    .module .module-ul .module-li-choice .choice-input{
        width:440px;
        height:32px;
        border: 1px solid #b9e9f2;
        text-align: center;
        line-height: 32px;
        color: #333;
        margin-left: 10px;
    }
    .btn{
        display: inline-block;
        width: 224px;
        height: 42px;
        font-size:22px;
        color: #fff;
        background-color: #13b5ea;
        text-align: center;
        line-height: 42px;
        border-radius: 3px;
        margin-top: 40px;
        cursor: pointer;
    }
    @media screen and (max-width:768px) {
        .module{
            width:100%;
            margin-top: 0.1rem;
        }
        .module .module-tit{
            display: inline-block;
            border-bottom: 1px solid #1a96d4;
            padding: 0.05rem 0.15rem 0.05rem 0.1rem;
            font-size:0.3rem;
        }
        .module .module-tit img{
            width:0.3rem;
            height:0.3rem;
        }
        .module .module-tit #all{
            width:0.3rem;
            height:0.3rem;
        }
        .module .module-ul{
            width:100%;
            font-size:0;
        }
        .module .module-ul .module-li{
            display: inline-block;
            width:100%;
            height:0.6rem;
            font-size:0.24rem;
            margin-top:0.2rem;
        }
        .module .module-ul .module-li .module-li-tit{
            display: inline-block;
            width:2.3rem;
            height:100%;
            font-size: 0.24rem;
            margin-left: 0rem;
            margin-right: 0.1rem;
        }
        .module .module-ul .module-li .module-li-tit .icon-bangzhu-{
            display: inline-block;
            float: right;
            font-size:0.3rem;
            color: #1a96d4;
            cursor: pointer;
            vertical-align: middle;
        }
        .module .module-ul .module-li .module-li-short{
            display: inline-block;
            width:2.6rem;
            height:100%;
            font-size:0.24rem;
            border: 1px solid #b9e9f2;
        }
        .module .module-ul .module-li .explain{
            display: block;
            width:5rem;
            position: absolute;
            border: 1px solid #1a96d4;
            border-radius: 10px;
            top:0.6rem;
            left:0;
            background-color: #fff;
            z-index:100;
            padding: 0.1rem 0.2rem;
            box-shadow:5px 5px 20px -5px #ccc
        }
        .module .module-ul .module-li .explain .icon-guanbi{
            position: absolute;
            top:5px;
            right:5px;
            font-size:0.3rem;
            cursor: pointer;
        }
        .module .module-ul .module-li .explain h1{
            font-size:0.3rem;
            color: #333;
        }
        .module .module-ul .module-li .explain p{
            font-size:0.24rem;
            color: #333;
        }
        .module .module-ul .module-subheading{
            width:100%;
            border-bottom: 1px solid #ccc;
            padding: 0.2rem 0;
        }
        .module .module-ul .module-subheading span{
            font-size:0.24rem;
            padding-left: 0.2rem;
        }
        .module .module-ul .module-subheading span .icon-bangzhu-{
            display: inline-block;
            font-size:0.3rem;
            color: #1a96d4;
            cursor: pointer;
            vertical-align: middle;
        }
        .module .module-ul .module-subheading .explain{
            display: block;
            width:5rem;
            position: absolute;
            border: 1px solid #1a96d4;
            border-radius: 10px;
            top:0.6rem;
            left:0;
            background-color: #fff;
            z-index:100;
            padding: 0.1rem 0.2rem;
            box-shadow:5px 5px 20px -5px #ccc
        }
        .module .module-ul .module-subheading .explain .icon-guanbi{
            position: absolute;
            top:5px;
            right:5px;
            font-size:0.3rem;
            cursor: pointer;
        }
        .module .module-ul .module-subheading .explain h1{
            font-size:0.3rem;
            color: #333;
        }
        .module .module-ul .module-subheading .explain p{
            font-size:0.24rem;
            color: #333;
        }
        .module .module-ul .module-li-choice{
            display: inline-block;
            width:100%;
            height:0.6rem;
            font-size:0.24rem;
            margin-top:0.2rem;
        }
        .module .module-ul .module-li-choice .choice{
            width:90%;
            height:0.6rem;
            text-align: center;
            line-height: 0.6rem;
            cursor: pointer;
            margin-left: 5%;
        }
        .module .module-ul .module-li-choice .choice.selected{
            border: 1px solid #1a96d4;
            color: #1a96d4;
            background-color: #d1edf8;
        }
        .module .module-ul .module-li-choice .choice-input{
            width:90%;
            height:0.6rem;
            text-align: center;
            line-height: 0.6rem;
            margin-left: 5%;
            padding: 0;
        }

        .btn{
            display: inline-block;
            width: 2rem;
            height: 0.6rem;
            font-size:0.36rem;
            line-height: 0.6rem;
            margin-top: 0.4rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/transfer.vue